import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import isGeographicDataType from 'scoreboard/components/is-geographic-data-type'
import { COUNTRY_FIELD_ID, STATE_PROVINCE_FIELD_ID, CITY_FIELD_ID } from './fields/geographic-ancestor-selector'

/**
 * Returns false if the given field may not be deleted due to being used by
 * other geographic fields
 * @param field
 * @param fields
 * @returns {boolean}
 */
function deleteGeographicFieldAllowed(field, fields) {
	return _.size(getGeographicFieldDependencies(field, fields)) == 0
}

/**
 * Returns dependency information for the given geographic field
 * for each field using the specified field
 * @param field
 * @param fields
 * @returns {*[]}
 */
function getGeographicFieldDependencies(field, fields) {
	// get the other geographic fields
	let geoFields = getOtherGeographicFields(field, fields)
	let geographicFieldDependencies = []
	_.each([COUNTRY_FIELD_ID, STATE_PROVINCE_FIELD_ID, CITY_FIELD_ID], geoFieldTypeId => {
		let fieldsForGeoFieldType = _.filter(geoFields, f => {
			return field.id == _.get(f, geoFieldTypeId)
		})
		_.each(fieldsForGeoFieldType, f => {
			let fieldDependency = {
				fieldLabel: field.label, // the label of the field being checked
				dependentFieldLabel: f.label, // the label of the field using the specified field
				geoFieldTypeId // the geographic field id found (ex 'countryFieldId')
			}
			geographicFieldDependencies.push(fieldDependency)
		})
	})
	return geographicFieldDependencies
}

/**
 * Return the geographic fields from a list of fields, other than the field
 * we are checking
 * @param field
 * @param fields
 * @returns {string[]}
 */
function getOtherGeographicFields(field, fields) {
	return _.filter(fields, f =>
		isGeographicDataType(f.dataType) && f.id != field.id)
}

/**
 * Builds dependency messages for a geographic field that is currently being
 * used by other geographic field(s).
 * For display in delete button tooltip message
 * @param field
 * @param fields
 * @returns {*[]}
 */
function geographicFieldDependencyMessage(field, fields) {
	let messages = []
	_.each(getGeographicFieldDependencies(field, fields), dep => {
		let message = i18n.get(
			'datasets.fields.geographic.cannotDeleteField',
			dep.fieldLabel,
			dep.dependentFieldLabel,
			geographicFieldIdLabel(dep.geoFieldTypeId)) + '<br>'
		messages.push(message)
	})
	return messages
}

/**
 * Returns a lowercase label for the given geographic field id for use in the
 * message displayed in a tooltip
 * ex 'countryFieldId' -> 'country'
 * @param geographicFieldId
 * @returns {string}
 */
function geographicFieldIdLabel(geographicFieldId) {
	let key
	switch (geographicFieldId) {
		case COUNTRY_FIELD_ID:
			key = 'datasets.field.fieldType.country'
			break
		case STATE_PROVINCE_FIELD_ID:
			key = 'datasets.field.fieldType.stateProvince'
			break
		case CITY_FIELD_ID:
			key = 'datasets.field.fieldType.city'
			break
	}
	return _.toLower(i18n.get(key))
}

export { deleteGeographicFieldAllowed }
export { geographicFieldDependencyMessage }
export { getOtherGeographicFields }
export { geographicFieldIdLabel }
